import React, { useContext } from "react";

import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { useTheme } from "@mui/material/styles";
// import useMediaQuery from "@mui/material/useMediaQuery";
import MessageIcon from "../../assets/message-cloud.png";
import SpeedoMeterIcon from "../../assets/speedometer-icon.png";
import { SpeedometerButton } from "../../components";
import { useNavigate, createSearchParams } from "react-router-dom";

import { AuthContext } from "../../context/AuthContext";

// Initialize Firebase

export const Home = () => {
  const navigate = useNavigate();
  const onClickButton = (speedometerType) => {
    navigate({
      pathname: "progress",
      search: `?${createSearchParams({
        type: speedometerType,
      })}`,
    });
  };

  return (
    <Box sx={{ flexGrow: 1, marginTop: 3 }}>
      <Grid container spacing={2}>
        <Grid item xs={9} md={6}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
              flexWrap: "wrap",
            }}
          >
            <SpeedometerButton onClick={() => onClickButton("1")}>
              <Avatar
                alt="icon"
                src={SpeedoMeterIcon}
                sx={{ width: 56, height: 56 }}
              />
            </SpeedometerButton>
            <SpeedometerButton onClick={() => onClickButton("2")}>
              <Avatar
                alt="icon"
                src={SpeedoMeterIcon}
                sx={{ width: 56, height: 56 }}
              />

              <Avatar
                alt="icon"
                src={SpeedoMeterIcon}
                sx={{ width: 56, height: 56 }}
              />
            </SpeedometerButton>
            <SpeedometerButton onClick={() => onClickButton("3")}>
              <Avatar
                alt="icon"
                src={SpeedoMeterIcon}
                sx={{ width: 56, height: 56 }}
              />

              <Avatar
                alt="icon"
                src={MessageIcon}
                sx={{ width: 56, height: 56 }}
              />
            </SpeedometerButton>
          </Box>
        </Grid>
        <Grid item xs={3} md={6} container direction="row" alignItems="center">
          <h3>Click side image for progress meter</h3>
        </Grid>
      </Grid>
    </Box>
  );
};
